import React from 'react'
import withStyles from '@mui/styles/withStyles';

export default withStyles((theme) => ({
    space: theme.mixins.header,
}))(({ classes }) => <div className={classes.space} />)
